// extracted by mini-css-extract-plugin
export default {"container":"genET8OtHidlImSbv6mQ","body":"qArzkEEr6pJrYmu11Yxs","error":"zb8u1UUxtoneLCcvVPmG"};